<template>
  <div
    class="ma-0 mx-auto"
    style="min-height: 100%; max-width: 1000px;"
  >
    <h2
      class="mb-3"
      style="color: white;"
    >My Account</h2>

    <alerts-panel
      v-if="overduePayments.length > 0 || upcomingPayments.length > 0 || generalAlerts.length > 0 || userInfo.credit > 0"
      :key="overduePayments.length + '-' + upcomingPayments.length + '-' + generalAlerts.length + '-' + userInfo.credit"
      :env="env"
      :credit="userInfo.credit"
      :error="overduePayments"
      :warning="upcomingPayments"
      :info="generalAlerts"
    />

    <div
      class="d-flex flex-column flex-md-row justify-center mx-auto" style="width: 100%;"
    >
      <div
        class="d-flex flex-column flex-wrap" style="width: 100%;"
      >
        <v-card
          class="mt-5 mx-auto pa-5"
          style="width: 100%;"
        >
          <div
            style="width: 100%;"
            class="d-flex flex-row jusity-space-between align-center mb-3"
          >
            <h3
              class="mr-auto text-left"
            >Personal Info</h3>

            <v-btn
              outlined
              color="primary"
              small
              @click="newuserInfo = Object.assign({}, userInfo); personalDialog=true"
              class="pl-3 ml-auto mr-0 mt-0"
            >
              <v-icon
                small
                class="mr-1"
              >mdi-pencil</v-icon>
              <span>Edit</span>
            </v-btn>
          </div>

          <div
            v-if="userInfo"
            class="d-flex flex-column justify-space-between
            flex-md-row"
            style="line-height: 1.7rem; font-family: var(--heading-font) !important;"
          >
            <div>
              <h3
                class="text-left"
                style="font-weight: bold; color: #222;"
              >{{ userInfo.fname }} {{ userInfo.lname }}</h3>
              <div>{{ getPerms(permissions) }}</div>

              <div
                v-if="userInfo.email"
              >{{ userInfo.email }}</div>

              <div
                v-if="userInfo.email2"
              >{{ userInfo.email2 }}</div>

              <div
                v-if="userInfo.email3"
              >{{ userInfo.email3 }}</div>

              <div
                v-if="userInfo.phone"
              >+{{ getPhone(userInfo.phone, 'phone') }}</div>

              <div
                v-if="userInfo.phone2"
              >+{{ getPhone(userInfo.phone2, 'phone2') }}</div>

              <div
                v-if="userInfo.phone3"
              >+{{ getPhone(userInfo.phone3, 'phone3') }}</div>

              <br>

              <h3
                class="text-left"
                style="font-weight: bold; color: #222;"
              >License Plates</h3>

              <div
                v-if="userInfo.license_plates"
              >{{ userInfo.license_plates }}</div>
            </div>

            <v-spacer />

            <div
              class="text-left text-md-right mt-5 mt-md-0"
            >
              <h3
                class="text-md-right text-left"
                style="font-weight: bold; color: #222;"
              >Mailing Address</h3>

              <div
                v-if="userInfo.mailing_line1 && userInfo.mailing_city || userInfo.mailing_state || userInfo.mailing_country || userInfo.mailing_zip"
              >
                <div>{{ userInfo.mailing_line1 }}</div>

                <div
                  v-if="userInfo.mailing_line2"
                >{{ userInfo.mailing_line2 }}</div>

                <div>{{ userInfo.mailing_city }}, {{ userInfo.mailing_state }} {{ userInfo.mailing_country }} {{ userInfo.mailing_zip }}</div>
              </div>
            </div>
          </div>
        </v-card>

        <v-card
          v-if="properties.length > 0"
          class="mt-5 mx-auto pa-5"
          style="width: 100%;"
        >

          <h3
            class="ml-0 mb-2 mr-auto text-left"
          >Properties</h3>
          <p class="guests-description">
            Click a property to view property details{{ env.registeredGuestsActive ? ' and manage people who are registered for facility access at this property.' : '.' }}
          </p>

          <v-expansion-panels
            class="mx-auto px-0"
            style="width: 100%;"
            flat
            tile
            hover
          >
            <v-expansion-panel
              v-for="(p, i) in properties"
              :key="'property' + i"
              readonly
              @click="$router.push('/dashboard/' + $route.path.match(/member|manager/i)[0] + '/property/' + p.id)"
            >
              <v-expansion-panel-header
                expand-icon="mdi-open-in-new"
                color="#E6E6E6"
              >
                <div
                  v-if="propertyHeight==100"
                >#{{ p.lot }}<br>{{ p.line1 }}<br>{{ p.line2 }}<br>{{ p.city }}, {{ p.state }} {{ p.country }}, {{ p.zip }}</div>

                <div
                  v-else
                >#{{ p.lot }}&nbsp;-&nbsp;{{ p.line1 }} {{ p.line2 }} {{ p.city }}, {{ p.state }} {{ p.country }}, {{ p.zip }}</div>
              </v-expansion-panel-header>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>

      </div>

      <div
        class="d-flex align-stretch"
        style="min-width: 280px;"
      >
        <v-card
          class="d-flex flex-column jusitfy-space-between mt-5 ml-0 ml-md-5 pa-5 px-5"
          style="width: 100%;"
        >
          <div
            style="height: 100%;"
          >
            <h3
              class="ml-0 mb-3 mr-auto text-left"
            >Settings</h3>

            <div
              v-if="emailLists.length > 0"
            >
              <h4
                class="text-left"
              >Email Opt-ins</h4>

              <hr>

              <v-checkbox
                v-for="(list, i) of emailLists"
                v-model="emailLists[i].value"
                :label="emailLists[i].name"
                hide-details
                class="my-2"
                @change="saveEmailOptIn(emailLists[i].id)"
              />
            </div>

            <h4
              v-if="permissions!==2"
              class="text-left mt-5"
            >Phone & Email Sharing</h4>

            <hr
              v-if="permissions!==2"
            >

            <div
              v-if="permissions!==2"
              class="mt-3"
              style="max-width: 500px;
              font-size: 14px;"
            >Per RCW 64.038.045, a member can request names and mailing addresses of all members. Click below if you also want your email addresses and phone numbers shared when such a request is made.</div>

            <v-checkbox
              v-if="permissions!==2"
              v-model="userInfo.phone_listed"
              label="Shared when requested by a member"
              hide-details
              class="my-2"
              @change="savePhoneListed()"
            />
          </div>
        </v-card>
      </div>

      <form-dialog
        v-if="personalDialog"
        :permissions="permissions"
        :formTitle="'Personal Info'"
        :formInputs="personalInput"
        :formModel="newuserInfo"
        formMethod="edit"
        :loading="personalLoading"
        @save="save()"
        @close="personalDialog=false"
      />

    </div>
  </div>
</template>

<script>
/* IMPORTS */
import { setPerms } from '@/assets/js/constants.js';
import formInputs from '@/assets/structures/updateMember.js';

import TextEdit from '@/components/TextEdit.vue';
import FormDialog from '@/components/crud-management/children/FormDialog.vue';
import AlertsPanel from '@/components/AlertsPanel.vue';
import fetchV2 from '../../../assets/js/fetchV2';

export default {
  name: 'MyInfo',

  components: {
    TextEdit,
    FormDialog,
    AlertsPanel,
  },

  props: {
    env: {
      type: Object,
      required: true,
    },

    permissions: {
      type: Number,
      required: true,
    },

    userInfo: {
      type: Object,
      required: true,
    },

    properties: {
      type: Array,
      required: true,
    },

    overduePayments: {
      type: Array,
      required: false,
      default: [],
    },

    upcomingPayments: {
      type: Array,
      required: false,
      default: [],
    },

    generalAlerts: {
      type: Array,
      required: false,
      default: [],
    },
  },

  data: () => ({
    windowWidth: 0,
    propertyHeight: 36,
    propertyPanels: [],
    newuserInfo: null,
    personalDialog: false,
    personalLoading: false,
    personalInput: {},
    emailLists: [],
    emailOptIns: [],
  }),

  watch: {
    properties(val) {
      if (this.properties.length <= 3) {
        this.propertyPanels = [0];
      }
    }
  },

  methods: {
    getEmailLists() {
      return new Promise((resolve, reject) => {
        fetchV2('GET /email_list/personal').then((data) => {
          return resolve(data);
        }).catch((err) => {
          console.error(err);
          this.$emit('error', 'An error occurred. Please contact ' + process.env.VUE_APP_SUPPORT_EMAIL + '.');
        })
      })
    },

    getEmailOptIns() {
      fetchV2('GET /email_list_x_user/personal').then((data) => {
        this.emailOptIns = data;
        this.getEmailLists().then((emailLists) => {

          emailLists.forEach((list) => {
            list.value = false;
          })

          this.emailOptIns.forEach((optIn) => {
            emailLists.forEach((list) => {
              if (optIn.email_list_id === list.id) {
                list.value = true;
              }
            })
          })

          this.emailLists = emailLists;
        })
      }).catch((err) => {
        console.error(err);
        this.$emit('error', 'An error occurred. Please contact ' + process.env.VUE_APP_SUPPORT_EMAIL + '.');
      })
    },

    saveEmailOptIn(id) {
      let body = {
        email_list_id: id,
      }

      fetchV2('PUT /email_list_x_user/personal', body).then((data) => {
        this.$emit('success-banner', 'Your email subscription has been updated!');
      }).catch((err) => {
        console.error(err);
        this.$emit('error', 'An error occurred. Please contact ' + process.env.VUE_APP_SUPPORT_EMAIL + '.');
      })
    },

    savePhoneListed() {
      let body = {
        phone_listed: this.userInfo.phone_listed,
      }

      fetchV2('PUT /users/phone_listed', body).then((data) => {
        this.$emit('success-banner', 'Your phone sharing settings have been updated!');

      }).catch((err) => {
        console.error(err);
        this.$emit('error', 'An error occurred. Please contact ' + process.env.VUE_APP_SUPPORT_EMAIL + '.');
        userInfo.phone_listed = !userInfo.phone_listed;
      })
    },

    save() {
      this.personalDialog = false;
      let body = Object.assign({}, this.newuserInfo);
      if (typeof body.phone === 'string') body.phone = body.phone.replace(/[\x28\x29\x20\x2b\x2d]/g, '');
      if (typeof body.phone2 === 'string') body.phone2 = body.phone2.replace(/[\x28\x29\x20\x2b\x2d]/g, '');
      if (typeof body.phone3 === 'string') body.phone3 = body.phone3.replace(/[\x28\x29\x20\x2b\x2d]/g, '');

      for (const [key, value] of Object.entries(body)) {
        if (body[key] && typeof body[key] === 'object') {
          body[key] = body[key].value;
        }
      }

      this.$emit('loading', 'Saving user information');
      fetchV2('PUT /users/personal', body).then((data) => {
        this.$emit('loading', false);
        this.$emit('success-banner', 'Your personal information has been updated!');
        this.$emit('refresh-userinfo');
      }).catch((err) => {
        console.error(err);
        this.$emit('loading', false);
        this.$emit('error', 'An error occurred. Please contact ' + process.env.VUE_APP_SUPPORT_EMAIL + '.');
      })
    },

    getPerms(val) {
      let s = Object.keys(setPerms).find((key) => {
        return setPerms[key] === val;
      });
      if (s != null)
        return s.charAt(0).toUpperCase() + s.substring(1, s.length).toLowerCase();
      else
        return null
    },

    getPhone(val, key) {
      if (val) {
        let f = val.replace(/[\x2b\x28\x29\x2d\x20]/g, '');
        let s = '';
        for (let i = 0; i < f.length; i++) {
          if (i === 1) s += ' ('; if (i === 4) s += ') '; if (i === 7) s += '-';
          s += f[i];
        }
        this.userInfo[key] = s;
      }
      return this.userInfo[key];
    },

    onResize() {
      this.windowWidth = document.body.clientWidth;
      if (this.windowWidth < 700) {
        this.propertyHeight = 100;
      }
      else {
        this.propertyHeight = 36;
      }
    }
  },

  destroyed() {
    window.removeEventListener('resize', this.onResize)
  },

  created () {
    window.addEventListener('resize', this.onResize)

    this.onResize();
    this.personalInput = formInputs.users;
    if (this.properties.length <= 3) {
      this.propertyPanels = [0];
    }
  },

  mounted() {
    this.getEmailOptIns();
  }
};
</script>

<style scoped>
  .gradient-background {
    background-image: linear-gradient(270deg,  var(--v-gray-base) 0%, var(--v-primary-base) 100% );
  }
  .alert-box {
    cursor: pointer;
  }
  .alert-box:hover {
    opacity: .75;
  }
</style>
